import { useContext } from "react";
import { InputStakeholderDialogContext, PageNewState } from ".";

export const useInputStakeholderDialogState = () => {
  const { pageState, setPageState } = useContext(InputStakeholderDialogContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
